import { render, staticRenderFns } from "./ProductCheckbox.vue?vue&type=template&id=7340c363"
import script from "./ProductCheckbox.vue?vue&type=script&lang=js"
export * from "./ProductCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports